export const IMPACT_CALCULATION_TITLE = 'Como calculamos seu impacto?';
export const IMPACT_DIPLOMA_NAME_MAX_LENGTH = 50;
